export enum DEVICESET_ACTION_TYPES {
    GET_DEVICESETS_START = 'deviceset/GET_DEVICESETS_START',
    GET_DEVICESETS_SUCCESS = 'deviceset/GET_DEVICESETS_SUCCESS',
    GET_DEVICESETS_FAILED = 'deviceset/GET_DEVICESETS_FAILED',
    GET_DEVICESETS_STATUS_START = 'deviceset/GET_DEVICESETS_STATUS_START',
    GET_DEVICESETS_STATUS_SUCCESS = 'deviceset/GET_DEVICESETS_STATUS_SUCCESS',
    GET_DEVICESETS_STATUS_FAILED = 'deviceset/GET_DEVICESETS_STATUS_FAILED',
}